import React from 'react';
import { PrivacyPolicyPresenter } from './presenter';

export const PrivacyPolicy: React.VFC = () => {
  return <PrivacyPolicyPresenter />;
};
